import { ClipboardList, MessageSquareText, Sparkles } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = [
  { icon: ClipboardList, n: "01", title: "Berätta vad du behöver", desc: "Välj nivå och eventuella tillval i vår offertförfrågan – det tar under en minut." },
  { icon: MessageSquareText, n: "02", title: "Vi återkommer med ett tydligt förslag", desc: "Du får snabbt svar med ett genomtänkt upplägg – kostnadsfritt och utan förpliktelser." },
  { icon: Sparkles, n: "03", title: "Vi putsar – du ser klart ut igen", desc: "Vi kommer som överenskommet och lämnar inget förrän resultatet är kristallklart." },
];

export const HowItWorks = () => (
  <section id="sa-fungerar-det" className="bg-brand-iceBg scroll-mt-24" data-testid="how-it-works">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-32">
      <div className="max-w-2xl">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-brand-blue">Så fungerar det</p>
        </Reveal>
        <Reveal delay={0.06}>
          <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink leading-tight">
            Från förfrågan till skinande rent – på tre steg
          </h2>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1}>
            <div className="relative" data-testid={`step-${i}`}>
              <span className="font-heading text-6xl font-extrabold text-brand-blue/10 select-none">{s.n}</span>
              <div className="mt-2 h-11 w-11 rounded-full bg-white border border-slate-100 shadow-[0_2px_10px_rgba(7,22,44,0.04)] flex items-center justify-center">
                <s.icon className="h-5 w-5 text-brand-blue" strokeWidth={1.75} />
              </div>
              <h3 className="mt-4 font-heading text-xl font-bold text-brand-ink tracking-tight">{s.title}</h3>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
